import React, { Component } from 'react';
import * as securityPost from './SecurityPost';
import { API_HOST } from './constants';
import { rejects } from 'assert';

const client_id = 357;
const url_redirect = "http://worldcup.trueid.net/";

let is_login = "ERROR";

class TrueMainNav extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isLogin: false,
      trueid: {
        uid: "",
        avatar: "",
        access_token: ""
      }
    };
    this.loginTrueID = this.loginTrueID.bind(this);
    this.logoutTrueID = this.logoutTrueID.bind(this);
    //window.TID.getstatus = window.TID.getstatus.bind(this);
    //window.TID.login = window.TID.login.bind(this);
    //

  }

  componentWillUpdate(nextProps, nextState) {
    const { isLogin } = nextState;

    if (this.state.isLogin !== isLogin) {
      //
      this.props.onLoginChange(isLogin);
    }
    this.loginAPITrueID();

  }

  componentDidMount() {
    this.loginAPITrueID();
    this.checkTrueIDLogin(null);
  }

  loginAPITrueID() {
    window.idAsyncInit = function (event) {
      window.TID.init(
        {
          'clientID': client_id, //Your client_id
          'version': 1.1,
          'redirect_uri': url_redirect //Your redirect_uri after finish
        }
      );
    };

  }

  handleTrueIDLogin(e) {
    this.loginSessionTrueID((havedata) => {
      if (havedata === false) {
        this.loginTrueIDStatus((havedata) => {
          if (havedata === false) {
            this.loginTrueID();
          }
        });
      }
    });
  }

  checkTrueIDLogin(e) {
    this.loginSessionTrueID((havedata) => {
      if (havedata === false) {
        this.loginTrueIDStatus((havedata) => {
        });
      }
    })
  }

  checkTrueIDLoginOpenWidget(e) {
    this.loginSessionTrueID((havedata) => {
      if (havedata === false) {
        this.loginTrueID();
      }
    })
  }

  loginSessionTrueID(havedata) {
    fetch(`${API_HOST}/store/token`, securityPost.Basic())
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      }).then(response => {
        if (response.havedata) {
          this.loginCallback(response.trueid.uid, response.trueid.avatar, response.trueid.access_token);
          havedata(true);
        } else {
          havedata(false);
        }
      });
  }

  loginTrueIDStatus(havedata) {
    window.TID.getstatus((response) => {
      if (response.status == 'connected') {
        let profile_avatar = "https://rp-statics.trueid.net/v0/b/trueid-84d04.appspot.com/o/image_profile%2F" + response.uid + ".jpg?alt=media";
        this.loginCallback(response.uid, profile_avatar, response.access_token);
        havedata(true);
      }
      else {
        havedata(false);
      }
    });
  }

  loginTrueID() {
    window.TID.login((response) => {
      if (response.status == 'connected') {
        let profile_avatar = response.profile.avatar;
        window.TID.getstatus((response) => {
          this.loginCallback(response.uid, profile_avatar, response.access_token);
        });
        this.loginCallback(response.profile.uid, response.profile.avatar, response.access_token);
      } else {
        this.setState({ isLogin: false });
      }
    });
  }

  loginCallback(uid, avatar, access_token) {
    let data = {
      uid: uid,
      avatar: avatar,
      access_token: access_token
    };
    this.loginSaveTrueID(data);
    this.setState({ isLogin: true, trueid: data });
  }

  loginSaveTrueID(trueid) {
    fetch(`${API_HOST}/store/token`, securityPost.BasicPost(trueid))
      .then(response => {
        if (response.ok) {
          //save in session cookie
        }
      });
  }

  loginTrueIDProfile(e) {
    e.preventDefault();
    window.location = "https://accounts.trueid.net/profile?client_id=" + client_id + "&redirect_uri=" + url_redirect + "&state=1";
  }

  logoutTrueID(e) {
    this.setState({
      isLogin: false
    });
    e.preventDefault();
    fetch(`${API_HOST}/store/remove`, securityPost.Basic())
      .then(response => {
        if (response.ok) {

          //remove in session
          window.location = "https://accounts.trueid.net/signout?client_id=" + client_id + "&return_to=" + url_redirect;
        }
      });
  }

  loginDisplayProfile() {
    let display = <div className="my-lg-0  navbar-toggler-right">
      <ul className="navbar-nav option-menu mobile">
        <li onClick={(e) => this.checkTrueIDLoginOpenWidget(e)}
          className="nav-link nav-item dropdown avatar-user"
          id="trueid-login-widget"
          data-lang="TH"
          data-type="normal"
          data-style="modal"
          data-width="800"
          data-height="350"
          data-button="custom">
        </li>
        <li onClick={(e) => this.checkTrueIDLoginOpenWidget(e)}
          className="nav-item nav-link"
          id="trueid-loginlnk-widget"
          data-lang="TH"
          data-type="normal"
          data-style="modal"
          data-width="800"
          data-height="350"
          data-button="custom">
          <i className="fa fa-user-circle px-1 px-lg-0" aria-hidden="true"></i>
        </li>
      </ul>
    </div>
    if (this.state.isLogin) {
      let avatarstyle = {
        backgroundImage: `url(${this.state.trueid.avatar})`,
        backgroundColor: '#fff',
        boxShadow: 'inset 0 0 5px rgba(0,0,0,.15)',
        display: 'inline-block',
        width: '28px',
        height: '28px',
        borderRadius: '28px',
        backgroundPosition: 'center',
        backgroundSize: 'contain'
      };
      display = <div className="my-lg-0  navbar-toggler-right">
        <ul className="navbar-nav option-menu mobile">
          <li className="nav-link nav-item dropdown avatar-user" id="trueid-login-widget" data-lang="th" data-type="normal" data-style="modal" data-width="800" data-height="350" data-button="custom">
            <a className="dropdown-toggle px-2 px-lg-0" href="#" id="XXX" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <span style={avatarstyle}></span>
            </a>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="XXX">
              <a onClick={(e) => this.loginTrueIDProfile(e)} className="dropdown-item" href="javascript:void(0);" target="_blank">My Profile</a>
              <a onClick={(e) => this.logoutTrueID(e)} href="javascript:void(0);" className="dropdown-item">Logout</a>
            </div>
          </li>
        </ul>
      </div>
    }
    return display;
  }

  redirectTo(e, url, section) {
    e.preventDefault();
    window.location = url;
  }

  render() {
    return (
      <header className="navbar navbar-expand-md navbar-light bg-faded p-0">
        <div className="smart-banner d-lg-none">
          <div className="container px-2">
            <div className="media">
              <div className="d-flex mt-2 mr-2 thumbnail-app">
                <span>
                  <object type="image/svg+xml" data="/assets/images/mainnav/logo-trueid-app.svg"
                    className="icon-app-svg media-object">
                    <img src="/assets/images/mainnav/logo-trueid.png" alt="TrueID logo application" />
                  </object>
                </span>
              </div>
              <div className="media-body d-flex flex-row justify-content-between">
                <div className="banner-info mb-0 mr-2">
                  <p>
                    <strong>TrueID</strong> ทรูไอดี – โหลดฟรี ไม่มีค่าใช้จ่าย ค่ายไหนก็โหลดได้ แอปเดียวจบ
                    ครบทุกไลฟ์สไตล์</p>
                </div>
                <div className="banner-install-button d-flex align-items-center">
                  <b className="btn" id="download-app-button">OPEN</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-nav w-100 affix" data-toggle="affix">
          <nav className="container my-2 my-lg-1">
            <div className="d-flex justify-content-between">
              <button className="js-offcanvas-trigger navbar-toggler navbar-toggler-left px-0 c-button is-active"
                type="button" data-offcanvas-trigger="off-canvas"
                href="#off-canvas" aria-controls="off-canvas" aria-expanded="true" aria-label="Toggle navigation"
                role="button" aria-pressed="true">
                <span className="c-button__text">
                  <span className="navbar-toggler-icon"></span>
                </span>
              </button>
              <a className="navbar-brand trueid-logo" href="#" onClick={(e) => this.redirectTo(e, 'http://home.trueid.net/', 'Header Home news-Section')}>
                <img src="/assets/images/worldcup2018/logo-trueid.svg" alt="TrueID logo" className="logo-svg img-fluid" />
              </a>
              <div className="collapse navbar-collapse" id="navbarsTrueID">
                <ul className="navbar-nav mr-auto mt-md-1">
                  <li className="nav-item">
                    <a target="_blank" onClick={(e) => this.redirectTo(e, 'http://home.trueid.net/', 'Header Home news-Section')} href="#"
                      className="nav-link">
                      <img src="/assets/images/mainnav/ico-home-small.png" className="d-lg-none" /> หน้าแรก</a>
                  </li>
                  <li className="nav-item dropdown">
                    <span className="nav-link dropdown-toggle" id="dropdown_music" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <img src="/assets/images/mainnav/ico-music-small.png"
                        className="d-lg-none" /> เพลง</span>
                    <div className="dropdown-menu" aria-labelledby="dropdown_music">
                      <a id="music_article" className="dropdown-item"
                        onClick={(e) => this.redirectTo(e, 'http://music.trueid.net/', 'Header Music news-Section')} href="#">
                        ข่าวสารวงการเพลง</a>
                      <a id="music_listening" className="dropdown-item"
                        onClick={(e) => this.redirectTo(e, 'http://www.truemusic.com/', 'Header TrueID Music-Section')}
                        href="#"> ฟังเพลง</a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://truetv.trueid.net/', 'Header Movie-Section')}  >
                      <img src="/assets/images/mainnav/ico-movie-small.png" className="d-lg-none" /> ดูหนัง</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://tv.trueid.net/', 'Header TV-Section')}  >
                      <img src="/assets/images/mainnav/ico-tv-small.png" className="d-lg-none" />
                      ดูทีวีออนไลน์</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://dara.trueid.net/', 'Header Entertainment-Section')} >
                      <img src="/assets/images/mainnav/ico-entertain-small.png" className="d-lg-none" />
                      บันเทิงดารา</a>
                  </li>
                  <li className="nav-item dropdown">
                    <span className="nav-link dropdown-toggle" id="dropdown_sport" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <img src="/assets/images/mainnav/ico-sports-small.png" className="d-lg-none" /> กีฬา</span>
                    <div className="dropdown-menu" aria-labelledby="dropdown_sport">
                      <a id="sport_update" className="dropdown-item"
                        onClick={(e) => this.redirectTo(e, 'http://sport.trueid.net/', 'Header Sport update-Section')} href="#">ข่าวกีฬา</a>
                      <a id="sport_livesoccer" className="dropdown-item"
                        onClick={(e) => this.redirectTo(e, 'http://sport.trueid.net/live', 'Header Live soccer-Section')}
                        href="#"> ดูบอลสด</a>
                    </div>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://clip.trueid.net/', 'Header Clip-Section')} >
                      <img src="/assets/images/mainnav/ico-clip-small.png" className="d-lg-none" />
                      คลิป</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link head_menu_travel" href="#" target="_blank"
                      onClick={(e) => this.redirectTo(e, 'http://travel.trueid.net/', 'Header Travel-Section')}  >
                      <img src="/assets/images/mainnav/ico-travel-small.png" className="d-lg-none" />
                      ท่องเที่ยว</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://travel.trueid.net/food/', 'Header Food-Section')} >
                      <img src="/assets/images/mainnav/ico-food-small.png" className="d-lg-none" /> ที่กิน</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://women.trueid.net/', 'Header Women-Section')} >
                      <img src="/assets/images/mainnav/ico-women-small.png" className="d-lg-none" />
                      ผู้หญิง</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" target="_blank" href="#"
                      onClick={(e) => this.redirectTo(e, 'http://home.trueid.net/package/', 'Header Package-Section')} >
                      <img src="/assets/images/mainnav/ico-package-small.png?t=1521902726"
                        className="d-lg-none" /> แพ็กเกจ</a>
                  </li>
                </ul>
              </div>
              {this.loginDisplayProfile()}
            </div>
          </nav>
          <div className="trueid-search p-2">
            <div className="container">
              <form action="http://home.trueid.net/search" method="get">
                <div className="input-group">
                  <input name="q" type="search" value="" placeholder="Search..." className="form-control" />
                  <input value="016881546338262774396:wm_yepp6-u" name="cx" type="hidden" />
                  <span className="input-group-btn">
                    <button className="btn btn-secondary close-search" type="submit">
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default TrueMainNav;



// WEBPACK FOOTER //
// ./src/TrueMainNav.js